module.exports = __webpack_public_path__ + "img/pos2croppedsm.79d84470.webp";